<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'direct-sale'">
  <div *ngIf="type === 'program'">
    <div class="view-container">

      <div class="view-header view-separator pt-0 gap-2">
        <div class="view-container-title w-12 md:w-3">
          <h1 class="view-main-title">{{'UserPages.UserClosedSale.ProgramTitle' | translate}}</h1>
        </div>
        <div class="flex align-items-center w-12 md:w-5 p-fluid">
          <span class="p-input-icon-left w-11">
            <input pInputText
              inputId="global_search"
              placeholder="{{'UserPages.UserClosedSale.DirectSaleProgramTable.SearchBarLabel' | translate}}"
              [(ngModel)]="searchTerm"
              (input)="filterProgram()"
              class="custom-input"/>
            <i class="pi pi-search custom-input-icon"></i>
          </span>
        </div>
        <div *ngIf="profile?.type == 1" class="flex w-12 md:w-4 justify-content-end gap-2 p-fluid">
          <p-button
            class="custom-text-button w-full header-button"
            styleClass="p-button-secondary p-button-outlined"
            label="{{'UserPages.UserClosedSale.DirectSaleProgramTable.InviteFruztyLabel' | translate}}"
            icon="pi pi-user"
            (click)="visibleInvite = true"/>
          <p-button
            class="custom-text-button w-full header-button"
            label="{{'UserPages.UserClosedSale.DirectSaleProgramTable.NewProgramButtonLabel' | translate}}"
            icon="pi pi-plus-circle"
            (click)="goToDirectSaleCreatePage()"/>
        </div>
      </div>

      <div class="view-body-container">
        <form [formGroup]="filterForm">
          <div class="flex flex-row flex-wrap align-items-center justify-content-between align-content-center view-separator gap-2">
            <div class="flex flex-row gap-2">
              <div class="flex">
                <p-dropdown
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.SpeciesFilter' | translate}}"
                  [options]="species"
                  optionLabel="nameEs"
                  formControlName="speciesId"
                  optionValue="id"
                  (onChange)="loadVarieties()"
                  [filter]="true"
                  filterBy="name"
                  [showClear]="true"
                  class="custom-dropdown custom-dropdown-sm bg-form"
                  styleClass="w-8rem xl:w-10rem">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="selectedSpecies">
                        <img loading="lazy" [src]="selectedSpecies.imageUrl | speciesImageUrl" style="width: 18px" alt=""/>
                        <div>{{ getSpeciesName(selectedSpecies) }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-specie pTemplate="item">
                      <div class="flex align-items-center gap-2">
                          <img loading="lazy" [src]="specie.imageUrl | speciesImageUrl" style="width: 18px" alt=""/>
                          <div>{{ getSpeciesName(specie) }}</div>
                      </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="flex">
                <p-dropdown
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.VarietyFilter' | translate}}"
                  optionLabel="name"
                  optionValue="id"
                  formControlName="varietyId"
                  [options]="varieties"
                  [filter]="true"
                  [showClear]="true"
                  filterBy="name"
                  (onChange)="onChangeVariety()"
                  class="custom-dropdown custom-dropdown-sm bg-form"
                  styleClass="w-8rem xl:w-10rem">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="selectedVariety">
                      <img loading="lazy" [src]="selectedVariety.urlIcon | speciesImageUrl" style="width: 18px"/>
                      <div>{{ selectedVariety.name }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-variety pTemplate="item">
                      <div class="flex align-items-center gap-2">
                          <img loading="lazy" [src]="variety.urlIcon | speciesImageUrl" style="width: 18px"/>
                          <div>{{ variety.name }}</div>
                      </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="flex">
                <input id="code"
                  formControlName="directSaleProgramId"
                  type="text"
                  pInputText
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.ExportOfferCode' | translate}}"
                  (keyup)="executeFilter()"
                  class="custom-input custom-input-sm bg-form w-8rem xl:w-10rem"
                  styleClass="w-8rem xl:w-10rem"/>
              </div>
              <div *ngIf="profile?.type == 1" class="flex">
                <p-dropdown
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.ImporterFilter' | translate}}"
                  optionLabel="companyName"
                  optionValue="id"
                  formControlName="importerId"
                  [options]="importers"
                  (onChange)="executeFilter()"
                  [showClear]="true"
                  class="custom-dropdown custom-dropdown-sm bg-form"
                  styleClass="w-8rem xl:w-10rem"/>
              </div>
              <div *ngIf="profile?.type == 2" class="flex">
                <p-dropdown
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.ExporterFilter' | translate}}"
                  optionLabel="companyName"
                  optionValue="id"
                  formControlName="exporterId"
                  [options]="exporters"
                  (onChange)="executeFilter()"
                  [showClear]="true"
                  class="custom-dropdown custom-dropdown-sm bg-form"
                  styleClass="w-8rem xl:w-10rem"/>
              </div>
              <div class="flex">
                <p-dropdown
                  placeholder="{{'UserPages.UserClosedSale.DirectSaleFilters.StatusFilter' | translate}}"
                  [options]="statusArray"
                  formControlName="isActive"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [autoDisplayFirst]="false"
                  (onChange)="executeFilter()"
                  class="custom-dropdown custom-dropdown-sm bg-form"
                  styleClass="w-8rem xl:w-10rem"/>
              </div>
            </div>

            <div class="flex flex-row gap-2">
              <p-button
                class="custom-text-button header-button"
                (click)="sidebarVisible = true"
                label="{{'UserPages.UserClosedSale.DirectSaleFilters.AdvancedShortFilters' | translate}}"
                styleClass="p-button-outlined p-button-secondary w-8rem xl:w-10rem">
                <span class="material-symbols-outlined mr-1" style="font-size:21px;">tune</span>
              </p-button>
              <p-button
                class="custom-text-button header-button"
                label="{{'UserPages.UserClosedSale.DirectSaleFilters.CleanFilters' | translate}}"
                (click)="cleanFilter()"
                styleClass="p-button-outlined p-button-secondary w-8rem xl:w-10rem">
                <span class="material-symbols-outlined mr-1" style="font-size:21px;">mop</span>
              </p-button>
            </div>

          </div>

        </form>

        <div class="grid gap-0 mb-4 mt-5" *ngIf="profile?.type === 1">
          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary border-50 total-programs-card">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'UserPages.UserClosedSale.TotalPrograms' | translate}}</p>
                </div>
                <div class="container-bottom-colors">
                  <div class="data-colors summary-card">
                      <span class="material-symbols-outlined icon-style">
                        calendar_month
                        </span>
                        <span class="summary-data">
                          {{totalProgramsStatistics}}
                        </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary border-50 total-containers-card">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'UserPages.UserClosedSale.TotalContainers' | translate}}</p>
                </div>
                <div class="container-bottom-colors">
                  <div class="data-colors summary-card">
                    <span class="material-symbols-outlined icon-style">
                      package_2
                    </span>
                    <span class="summary-data">
                      {{totalContainersStatistics}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary border-50 total-pallets-card">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'UserPages.UserClosedSale.TotalPallets' | translate}}</p>
                </div>
                <div class="container-bottom-colors">
                  <div class="data-colors summary-card">
                      <span class="material-symbols-outlined icon-style">
                        pallet
                        </span>
                        <span class="summary-data">
                          {{totalPalletsStatistics}}
                        </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 5px;" class="list-scroll">
          <p-dataView #dv [value]="offersFiltered"
          [lazy]="true"
          (onLazyLoad)="getExportOffersPage($event)"
          [paginator]="true"
          [rows]="lastSize"
          [first]="lastPage"
          [totalRecords]="totalCount"
          emptyMessage="{{'UserPages.UserClosedSale.NotInformationMessageText' | translate}}"
          [loading]="loading"
          currentPageReportTemplate="{first} - {last} of {totalRecords}">
            <ng-template let-offer pTemplate="listItem">
              <div class="col-12" style="margin-bottom: 20px;">
                <app-direct-sale-detail
                [offer]="offer"
                (ShowFirstConfirmEvent)="validateDeleteProgram($event)"
                (ShowDirectSaleProgramCreateModal)="showDirectSaleProgramCreateModal($event)"
                (ShowOfferDetailDialogEvent)="showOfferDetailDialog($event)"
                (ShowAssignPalletStock)="goToAssignPalletStock($event)"
                (ShowEditPalletStock)="goToEditPalletStock($event)"

                >
              </app-direct-sale-detail>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>

    </div>
  </div>
  <div *ngIf="type === 'purchase-orders' && profile?.type == 1">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <h1 class="title-main">{{'ProgramTab.ProgramRequestOrder' | translate}}</h1>
        </div>
        <div class="col-12 md:col-5 p-fluid flex align-items-center">
          <span class="p-input-icon-right">
            <input pInputText inputId="global_search" placeholder="Ingrese la información a consultar" class="p-inputtext-sm"/>
            <i class="pi pi-search"></i>
          </span>
        </div>
        <div>
        </div>
      </div>

      <div class="body-card">
        <app-filter-component
        [statusArray]="programRequestStatusItem"
        (ExecuteFilterEvent)="filterProgramRequestEvent($event)"
        (AdvanceFilterEvent)="showAdvancedFilter($event)"
        (CleanFilterEvent)="cleanFilterPurchaseOrder()"
        >

        </app-filter-component>
        <p-dataView #dv [value]="programRequestInfo" [rows]="5" [paginator]="true" emptyMessage="{{'UserPages.UserClosedSale.NotInformationMessageText' | translate}}" [loading]="loading">
          <ng-template let-info pTemplate="listItem">
            <div class="col-12" style="margin-bottom: 20px;">
              <div class="card-row">
                <div class="container-row">
                  <div class="row-main">
                    <div class="section-left">
                      <div class="container-flex-fit">
                        <div class="container-img">
                          <img loading="lazy" [src]="getIconUrl(info.programRequest.variety.urlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; height: auto;" alt="" *ngIf="info.programRequest.variety.urlIcon"/>
                          <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!info.programRequest.variety.urlIcon">
                            no_photography
                          </span>
                        </div>
                        <div class="container-variety">
                          <h2 class="text-main" style="font-size: medium;" >{{info.programRequest.variety.species | speciesName}}</h2>
                          <!--
                            <span style="text-transform: uppercase; font-size: medium;">{{info.programRequest.variety.name}}</span>
                          -->
                          <span style="font-weight: bolder; color: #8c2b87; font-size: small;">Id: {{info.programRequest.id}} </span>
                        </div>
                      </div>

                      <div class="container-flex-fit">
                        <div class="flex align-items-center justify-content-center">
                          <img  loading="lazy" style="width: 100%; max-width: 38px; height: 24px;" alt="" src="../../../../assets/img/container_icon_2.png" >
                          <span style="font-size: small; font-weight: bold; margin-left: 5px;">
                            {{info.programRequest.palletQuantity * getTotalWeekRowProgramRequest(info.programRequest) }}
                          </span>
                        </div>
                      </div>
                      <div class="container-flex-fit">
                        <div class="flex align-items-center justify-content-end">
                          <span style="font-weight: bolder; color: #8c2b87; font-size: small; height: auto;" >{{info.programRequest.pricePerCase | currency: 'USD':'US$'}}/{{info.programRequest.typeSale}}</span>
                        </div>
                      </div>

                    </div>

                    <div class="section-right" >
                      <div class="container-flex-between">
                        <div class="flex justify-content-start align-items-center container-flex-full">
                          <img loading="lazy" [flag]="info.programRequest.country" height="50px" alt=""/>
                          <div class="flex flex-column" style="margin-left: 10px;">
                            <span style="font-weight: bolder; font-size: small;">{{info.programRequest.country.name}}</span>
                          </div>
                        </div>
                        <div class="container-nave">
                          <!-- <span class="material-symbols-outlined" style="color: #6da043;">directions_boat</span> -->
                          <span class="material-symbols-outlined" style="color: #6da043;"> flight</span>
                          <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                        </div>
                        <div style="margin-left: 10px;" class="flex justify-content-start align-items-center container-flex-full">
                          <img loading="lazy" [flag]="info.programRequest.countryTo" height="50px" alt=""/>
                          <div class="flex flex-column" style="margin-left: 10px;">
                            <span style="font-weight: bolder; font-size: small;">{{info.programRequest.countryTo.name}}</span>
                            <span style="font-size: small;">
                              <!-- {{'UserPages.UserClosedSale.ProductDetail.DestinationPortText' | translate}} -->
                              <!-- {{info.programRequest.portTo?.name}} -->
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="container-flex-fit pd-lef pd-right">
                        <p-tag *ngIf="info.programRequest.programRequestStatus == 0" [value]="getStatusValue(info.programRequest.programRequestStatus)" [style]="{ 'display': 'grid', 'width': '100%', 'min-width': '60px', 'background-color': '#F1D0D0', 'color': '#9E4343', 'font-size':'small'}" ></p-tag>
                        <p-tag *ngIf="info.programRequest.programRequestStatus == 1" [value]="getStatusValue(info.programRequest.programRequestStatus)" [style]="{ 'display': 'grid', 'width': '100%', 'min-width': '60px', 'background-color': '#C3DBA2', 'color': '#4D6A34'}"></p-tag>
                        <p-tag *ngIf="info.programRequest.programRequestStatus == 2" [value]="getStatusValue(info.programRequest.programRequestStatus)" [style]="{ 'display': 'grid', 'width': '100%', 'min-width': '60px', 'background-color': '#D7D7D7', 'color': '#6C7A8F'}"></p-tag>
                        <div style="margin-left: 1em;">
                          <p-button
                            [icon]="info.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                            styleClass="p-button-rounded p-button-outlined"
                            (click)="setVisibleProgramRequestDetail(info)"
                            >
                          </p-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div  *ngIf="info.expanded" class="container-flex-between-start">
                  <div class="container-flex-fit-medium">
                    <div class="with-flex">
                      <div class="width-100 container-subtitle">
                        <span class="section-title">{{'UserPages.UserClosedSale.ProductDetailText' | translate}}</span>
                      </div>
                      <div class="col-6 flex flex-row align-items-center">
                        <span class="material-symbols-outlined info-icon">
                          pallet
                          </span>
                        <span class="info-text">
                          {{'UserPages.UserClosedSale.ProductDetail.CasePerPalletsText' | translate}}:
                          {{info.programRequest.caseQuantityPerPallet}}
                        </span>
                      </div>
                      <div class="col-6 flex flex-row align-items-center">
                        <span class="material-symbols-outlined info-icon" >
                          weight
                          </span>
                          <span class="info-text">
                            {{'UserPages.UserClosedSale.ProductDetail.NetKilosText' | translate}}:
                            {{info.programRequest.netKilos ? info.programRequest.netKilos + ' kg' : '-' }}
                          </span>
                      </div>
                      <div class="col-6 flex flex-row align-items-center">
                        <img loading="lazy" class="info-icon" style="width: 100%; max-width: 25px; height: 20px;" alt="" src="../../../../assets/img/container_icon_2.png" >
                          <span class="info-text">
                            {{'UserPages.UserClosedSale.ProductDetail.ProgramContainersText' | translate}}:
                            {{info.programRequest.containersNumber ?  info.programRequest.containersNumber / 20 : '-'}}
                          </span>
                      </div>
                      <div class="col-6 flex flex-row align-items-center">
                        <span class="material-symbols-outlined info-icon">
                          inventory_2
                          </span>
                          <span class="info-text">
                            {{'UserPages.UserClosedSale.ProductDetail.BoxTypeText' | translate}}:
                            <app-text-preview
                            [classStyle]="customClass"
                              [text]="info.programRequest.boxType ? info.programRequest.boxType  : '-'"
                              [maxLength]="60"
                              >
                            </app-text-preview>
                          </span>
                      </div>
                      <div class="col-6 flex flex-row align-items-center">
                        <span class="material-symbols-outlined info-icon" >
                          paid
                          </span>
                        <span class="info-text">
                          {{'UserPages.UserClosedSale.ProductDetail.PaymentMethodText' | translate}}:
                          {{info.programRequest.paymentAgainstBL + '%' + '/' + info.programRequest.typeSale }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="expand-right">
                    <div class="container-flex-fit">
                      <div class="column-flex">
                        <div class="container-subtitle">
                          <span class="section-title">{{'UserPages.UserClosedSale.AgreementText' | translate}}</span>
                        </div>
                        <div class="row-roles">
                          <span class="material-symbols-outlined info-icon" style="font-size: 17px;margin-top: 3px;">
                            person
                          </span>
                          <div class="flex-wrap">

                            <span class="info-text-program">
                              Importer:
                            </span>
                            <span class="program-info">
                              <app-text-preview-tooltip
                              [text]="info.programRequest.importer.companyName"
                              [maxWidth]="100"
                              >
                            </app-text-preview-tooltip>
                          </span>
                        </div>
                        </div>
                        <div class="row-roles">
                          <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 3px;">
                            person
                          </span>
                            <div class="flex-wrap">

                              <span class="info-text-program">
                                Consignee:
                              </span>
                              <span class="program-info">
                                <app-text-preview-tooltip
                                [text]="info.programRequest.consignee.companyName ?? '-'"
                                [maxWidth]="100"
                                >
                              </app-text-preview-tooltip>
                            </span>
                          </div>
                        </div>
                        <div class="row-roles">
                            <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 3px;">
                              person
                            </span>
                            <div class="flex-wrap">

                              <span class="info-text-program">
                                Notify:
                              </span>
                              <span class="program-info">
                                <app-text-preview-tooltip
                                [text]="info.programRequest.notify.companyName ?? '-'"
                                [maxWidth]="100"
                                >
                              </app-text-preview-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container-flex-fit">
                      <div class="column-flex">
                        <div class="container-subtitle">
                          <span class="section-title">{{'UserPages.UserClosedSale.week/yearText' | translate}}</span>
                        </div>
                        <div class="col-12">
                          <div class="grid">
                            <div class="flex flex-column">
                              <div class="flex flex-row justify-content-start gap-1">
                                <div class="flex align-items-center" style="width: 67px;">
                                  <span class="material-symbols-outlined info-icon">
                                    calendar_today
                                  </span>
                                  <span class="info-text-program">
                                    {{'UserPages.UserClosedSale.FromProgramText' | translate}}
                                  </span>
                                </div>
                                <div class="flex align-items-center">
                                  <span class="date-info">
                                    {{info.programRequest.startWeek}} / {{info.programRequest.startWeekYear}}
                                </span>
                                </div>
                              </div>
                              <div class="flex flex-row justify-content-start gap-1">
                                <div class="flex align-items-center" style="width: 67px;">
                                  <span class="material-symbols-outlined info-icon">
                                    calendar_today
                                  </span>
                                  <span class="info-text-program">
                                    {{'UserPages.UserClosedSale.ToProgramText' | translate}}
                                  </span>
                                </div>
                                <div class="flex align-items-center">
                                  <span class="date-info">
                                    {{info.programRequest.endWeek}} / {{info.programRequest.endWeekYear}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container-flex-fit">
                      <div class="column-flex-fit">
                        <div class="mb-2" pTooltip="{{'PurchaseOrderExporterActions.ViewActionText' | translate}}" >
                          <button (click)="selectProgramRequestDetail(info)" pButton label="{{'PurchaseOrderExporterActions.ViewActionText' | translate}}" class="p-button-outlined p-button-sm" icon="pi pi-eye" size="small"  [style]="{ 'width': '100%', 'height': '25px', 'max-width': '120px'}">

                          </button>
                        </div>
                        <div *ngIf="info.programRequest.programRequestStatus == 0" class=" mb-2" pTooltip="{{'PurchaseOrderExporterActions.ApproveText' | translate}}"  tooltipPosition="bottom">
                            <button (click)="goToDirectSaleCreateFrom(info.programRequest.guid)" pButton label="{{'PurchaseOrderExporterActions.ApproveText' | translate}}" class="p-button-sm" icon="pi pi-check" size="small"  [style]="{ 'width': '100%', 'height': '25px', 'max-width': '120px'}">

                            </button>
                        </div>
                        <div  *ngIf="info.programRequest.programRequestStatus == 0" class=" mb-2" pTooltip="{{'PurchaseOrderExporterActions.RejectText' | translate}}"  tooltipPosition="bottom" >
                          <button pButton (click)="updateProgramRequest(info.programRequest.guid, 2)" label="{{'PurchaseOrderExporterActions.RejectText' | translate}}"  class="p-button-sm p-button-danger"  severity="danger" icon="pi pi-times" size="small"  [style]="{ 'width': '100%', 'height': '25px', 'max-width': '120px'}" >

                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>

  <!-- tab para importador  -->
  <div *ngIf="type === 'purchase-orders' && profile?.type == 2">
    <app-import-program-request-list
    [programRequestInfo]="programRequestInfo"
    (visibleInviteEvent)="showInviteImporter()"
    >

    </app-import-program-request-list>
  </div>
</app-user-dashboard>

<p-dialog header="{{'UserPages.UserClosedSale.DialogHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleOfferDetailDialog" [style]="{width: '80%'}">
  <app-export-offer-detail [offer]="selectedExportOffer" [productCertificateTypes]="selectedProductCertificateTypes" [packagingTypes]="selectedPackagingTypes"></app-export-offer-detail>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserClosedSale.ModalCloseButton' | translate}}" (onClick)="closeOfferDetailDialog()"></p-button>
  </ng-template>
</p-dialog>

<p-confirmDialog acceptLabel="{{'UserPages.UserClosedSale.YesLabel' | translate}}" rejectLabel="{{'UserPages.UserClosedSale.NotLabel' | translate}}" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>

<p-dialog
  header="{{'UserPages.UserClosedSale.ModalTitle' | translate}}"
  [(visible)]="visibleInvite"
  [style]="{width: '50vw'}"
  [resizable]="false" [modal]="true" [draggable]="false"
>
  <app-closed-sale-join-request
    (handleCloseVisibility)="visibleInvite = false"
  />
</p-dialog>

<p-dialog header="{{'DirectSaleProgramModal.HeaderCreateTitle' | translate}}" [(visible)]="directSaleProgramModalVisible" [style]="{width: '70vw'}" [modal]="false">
  <div *ngIf="selectedExportOfferInformation">
  <form [formGroup]="directSaleProgramFormGroup" #directSaleProgramFormDirective="ngForm">
    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="field col-12 md:col-6 lg:col-4">
        <label for="importerId" style="font-weight: bolder;">{{'DirectSaleFormPage.ImporterFieldLabel' | translate}} *</label>
          <p-dropdown id="importerId"
          formControlName="importerId"
          [options]="importers"
          optionValue="id"
          [(ngModel)]="selectedExportOfferInformation.directSalePrograms[0].importerId"
          optionLabel="companyName"
          [filter]="true"
          filterBy="companyName"
          [showClear]="false"
          placeholder="{{'DirectSaleFormPage.ImporterFieldLabel' | translate}}"
          (onChange)="onChangeImporter()">
        </p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['importerId'].invalid" class="p-error">{{'importerId' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label for="consigneeId" style="font-weight: bolder;">{{'DirectSaleFormPage.ConsigneeFieldLabel' | translate}} *</label>
        <p-dropdown id="consigneeId"
          formControlName="consigneeId"
          [options]="consignees"
          optionValue="id"
          [(ngModel)]="selectedExportOfferInformation.directSalePrograms[0].consigneeId"
          optionLabel="companyName"
          [filter]="true"
          filterBy="companyName"
          [showClear]="false"
          placeholder="{{'DirectSaleFormPage.ConsigneeFieldLabel' | translate}}">
        </p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['consigneeId'].invalid" class="p-error">{{'consigneeId' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label for="notifyId" style="font-weight: bolder;">{{'DirectSaleFormPage.NotifyFieldLabel' | translate}} *</label>
        <p-dropdown id="notifyId"
          formControlName="notifyId"
          [options]="notifies"
          optionValue="id"
          optionLabel="companyName"
          [(ngModel)]="selectedExportOfferInformation.directSalePrograms[0].notifyId"
          [filter]="true"
          filterBy="companyName"
          [showClear]="false"
          placeholder="{{'DirectSaleFormPage.NotifyFieldLabel' | translate}}">
        </p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['notifyId'].invalid" class="p-error">{{'notifyId' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="importToCountryId">{{'DirectSaleFormPage.DestinationCountryFieldLabel' | translate}} *</label>
        <p-dropdown id="importToCountryId"
          [options]="countries"
          formControlName="importToCountryId"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="selectedExportOfferInformation.directSalePrograms[0].destinationCountryId"
          (onChange)="onChangeImportToCountry()"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          placeholder="{{'DirectSaleFormPage.DestinationCountryFieldLabel' | translate}}">
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2" *ngIf="selectedCountryTo">
              <img loading="lazy" [flag]="selectedCountryTo.code" style="width: 18px" alt=""/>
              <div>{{ selectedCountryTo | countryDescription }}</div>
            </div>
          </ng-template>
          <ng-template let-country pTemplate="item">
            <div class="flex align-items-center gap-2">
              <img loading="lazy" [flag]="country" style="width: 18px" alt=""/>
              <div>{{ country | countryDescription }}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['importToCountryId'].invalid" class="p-error">{{'importToCountryId' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="portToId">{{'DirectSaleFormPage.DestinationPortFieldLabel' | translate}} *</label>
        <p-dropdown id="portToId"
          [options]="ports"
          formControlName="portToId"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          placeholder="{{'DirectSaleFormPage.DestinationPortFieldLabel' | translate}}"></p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['portToId'].invalid" class="p-error">{{'portToId' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="containersPerWeek">{{'DirectSaleFormPage.ContainersPerWeekFieldLabel' | translate}} *</label>
        <p-inputNumber id="containersPerWeek" formControlName="containersPerWeek" [showButtons]="false" [useGrouping]="false" [min]="1" [max]="100000" placeholder="{{'DirectSaleFormPage.ContainersPerWeekFieldLabel' | translate}}"/>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['containersPerWeek'].invalid" class="p-error">{{'containersPerWeek' | formErrorMessage: directSaleProgramFormGroup}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="startWeek">{{'DirectSaleFormPage.StartWeekFieldLabel' | translate}} *</label>
        <p-inputNumber id="startWeek" formControlName="startWeek" [showButtons]="true" [useGrouping]="false" [min]="1" [max]="52" placeholder="{{'DirectSaleFormPage.StartWeekFieldLabel' | translate}}"/>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['startWeek'].invalid" class="p-error">{{'startWeek' | formErrorMessage: directSaleProgramFormGroup}}</small>
        <small *ngIf="submit && directSaleProgramFormGroup.getError('endWeekRangeError')" class="p-error">{{'MessageService.ExportOffer.ClosedSaleWeekRangeError' | translate}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="startWeekYear">{{'DirectSaleFormPage.StartYearFieldLabel' | translate}} *</label>
        <p-dropdown
        id="startWeekYear"
        formControlName="startWeekYear"
        [options]="years"
        optionLabel="label"
        optionValue="value"
        placeholder="{{'DirectSaleFormPage.StartYearFieldLabel' | translate}}">
      </p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.controls['startWeekYear'].invalid" class="p-error">{{'startWeekYear' | formErrorMessage: directSaleProgramFormGroup}}</small>
        <small *ngIf="submit && directSaleProgramFormGroup.getError('endWeekYearRangeError')" class="p-error">{{'MessageService.ExportOffer.ClosedSaleYearRangeError' | translate}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="endWeek">{{'DirectSaleFormPage.EndWeekFieldLabel' | translate}}</label>
        <p-inputNumber id="endWeek" formControlName="endWeek" [showButtons]="true" [useGrouping]="false" [min]="1" [max]="52" placeholder="{{'DirectSaleFormPage.EndWeekFieldLabel' | translate}}"/>
        <small *ngIf="submit && directSaleProgramFormGroup.getError('endWeekRangeError')" class="p-error">{{'MessageService.ExportOffer.ClosedSaleWeekRangeError' | translate}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4">
        <label style="font-weight: bolder;" for="endWeekYear">{{'DirectSaleFormPage.EndYearFieldLabel' | translate}}</label>
        <p-dropdown
        id="endWeekYear"
        formControlName="endWeekYear"
        [options]="years"
        optionLabel="label"
        optionValue="value"
        placeholder="{{'DirectSaleFormPage.EndYearFieldLabel' | translate}}"></p-dropdown>
        <small *ngIf="submit && directSaleProgramFormGroup.getError('endWeekYearRangeError')" class="p-error">{{'MessageService.ExportOffer.ClosedSaleYearRangeError' | translate}}</small>
      </div>
    </div>
    <div class="grid mr-2 ml-2" style="margin-top: 30px;">
      <div class="col-12 md:col-4 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'DirectSaleFormPage.TotalWeeksLabel' | translate}}: </label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{ totalWeeks }}</span>
      </div>
      <div class="col-12 md:col-4 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'DirectSaleFormPage.TotalPalletsScheduledLabel' | translate}}: </label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{totalPallets}}</span>
      </div>
      <div class="col-12 md:col-4 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'DirectSaleFormPage.TotalContainersLabel' | translate}}: </label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{totalContainers}}</span>
      </div>
    </div>
  </form>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="{{'DirectSaleProgramModal.CancelButtonLabel' | translate}}" (onClick)="directSaleProgramModalVisible = false" [loading]="loading" styleClass="p-button-outlined"></p-button>
    <p-button label="{{'DirectSaleProgramModal.SaveButtonLabel' | translate}}" (onClick)="saveDirectSaleProgram()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserImportRequest.ImportRequestTable.ImportRequestDialog.Header' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleProgramRequestDetailDialog" [style]="{width: '80%'}">
  <!-- <div class="grid"> -->
    <app-program-request-detail [programRequestInformation]="selectedProgramRequest"></app-program-request-detail>
  <!-- </div> -->
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserImportRequest.ImportRequestTable.ImportRequestDialog.CloseButton' | translate}}" (onClick)="visibleProgramRequestDetailDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [modal]="false" [draggable]="false" [(visible)]="visibleDeleteConfirmOne" [style]="{width: '800px'}" [dismissableMask]="true">
  <div class="w-full">
      <div style="margin-top: 20px;" class="flex justify-content-center">
          <span class="material-symbols-outlined" style="font-size: 100px; color: #8B2222;">
            delete
            </span>
      </div>
      <h2 style="text-align: center;">{{'ConfirmDeleteDirectSaleOne.ConfirmTextOne'| translate}}</h2>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'ConfirmDeleteDirectSaleOne.CancelDeleteButtonOne'| translate}}" styleClass="p-button-outlined" (onClick)="visibleDeleteConfirmOne = false"></p-button>
        <p-button label="{{'ConfirmDeleteDirectSaleOne.ConfirmButtonOne'| translate}}"(onClick)="showSecondConfirm()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [resizable]="false" [modal]="false" [draggable]="false" [(visible)]="visibleDeleteConfirmTwo" [style]="{width: '800px'}" [dismissableMask]="true" >

  <div class="w-full">
    <div style="margin-top: 20px;" class="flex justify-content-center">
      <span class="material-symbols-outlined" style="font-size: 100px; color: #8B2222;">
        delete
        </span>
    </div>
    <h2 style="text-align: center;">{{'ConfirmDeleteDirectSaleTwo.ConfirmTitleTwo'| translate}}</h2>
    <div class="flex justify-content-center">
      <span style="text-align: center;">{{'ConfirmDeleteDirectSaleTwo.ConfirmTextTwo'| translate}}</span>
    </div>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'ConfirmDeleteDirectSaleTwo.CancelDeleteButtonTwo'| translate}}" styleClass="p-button-outlined" (onClick)="visibleDeleteConfirmTwo = false"></p-button>
        <p-button label="{{'ConfirmDeleteDirectSaleTwo.ConfirmButtonTwo'| translate}}"(onClick)="deactivateProgram()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDeleteConfirmTwo" [style]="{width: '800px'}">

  <div class="w-full">
    <div style="margin-top: 20px;" class="flex justify-content-center">
      <span class="material-symbols-outlined" style="font-size: 100px; color: #8B2222;">
        delete
        </span>
    </div>
    <h2 style="text-align: center;">{{'ConfirmDeleteDirectSaleTwo.ConfirmTitleTwo'| translate}}</h2>
    <div class="flex justify-content-center">
      <span style="text-align: center;">{{'ConfirmDeleteDirectSaleTwo.ConfirmTextTwo'| translate}}</span>
    </div>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'ConfirmDeleteDirectSaleTwo.CancelDeleteButtonTwo'| translate}}" styleClass="p-button-outlined" (onClick)="visibleDeleteConfirmTwo = false"></p-button>
        <p-button label="{{'ConfirmDeleteDirectSaleTwo.ConfirmButtonTwo'| translate}}"(onClick)="deactivateProgram()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCreateConfirm" [style]="{width: '800px'}">

  <div class="w-full">
    <div>
      <h2 style="text-align: center;">{{'ConfirmCreateSale.Title'| translate}}</h2>
    </div>
    <div style="margin-top: 20px;" class="flex justify-content-center">
      <img loading="lazy" [src]="'../../../../assets/img/create-direct-sale-icon.png'" style="width: 200px" alt=""/>
    </div>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'ConfirmCreateSale.EmptyButtonLabel'| translate}}" styleClass="p-button-outlined" (onClick)="goToDirectSaleCreatePage()"></p-button>
        <p-button label="{{'ConfirmCreateSale.FromTemplateLabel'| translate}}"(onClick)="deactivateProgram()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleValidationDelete" [style]="{width: '800px'}">

  <div class="w-full">
    <div style="margin-top: 20px;" class="flex justify-content-center">
      <span class="material-symbols-outlined" style="font-size: 100px; color: #8B2222;">
        cancel
        </span>
    </div>
    <h2 style="text-align: center;">{{'NoDeleteOrderMessage.TitleOrder'| translate}}</h2>
    <div class="flex justify-content-center">
      <span style="text-align: center;">{{'NoDeleteOrderMessage.Message'| translate : {orderSequence: orderSequence}   }}</span>
    </div>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'NoDeleteOrderMessage.CancelText'| translate}}" styleClass="p-button-outlined" (onClick)="visibleValidationDelete = false"></p-button>
        <p-button label="{{'NoDeleteOrderMessage.ReviewText'| translate}}"(onClick)="goToOrderDetail()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- <p-dialog header="{{'AssignStock.AssignPalletTitle' | translate}}" [(visible)]="visibleStockDialog"  [style]="{width: '70vw'}" [resizable]="false" [draggable]="false">
    <div *ngIf="directSaleGuid">
      <app-assign-stock #assignStockComponent [programOrderGuid]="directSaleGuid" [isProgramLoad]="true" (onCancelAssignStock)="cancelAssign()" (onAssignStock)="assignProgram()" ></app-assign-stock>
    </div>
  <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="{{'AssignStock.CancelLabel' | translate}}" styleClass="p-button-outlined" (click)="cancelAssign()" [loading]="loading"></p-button>
        <p-button label="{{'AssignStock.AssignLabel' | translate}}" (click)="invokeAssignPalletStock()" [loading]="loading"  ></p-button>
      </div>
  </ng-template>
</p-dialog> -->

<p-sidebar [(visible)]="sidebarVisible" position="right" class="advanced-form-sidebar">
  <ng-template pTemplate="header">
    <p class="my-0 font-medium text-lg text-gray-800">{{'AdvancedFilters.SideBarTitle' | translate}}</p>
  </ng-template>

  <div class="flex flex-column justify-content-center p-2 gap-3 mt-3">
    <form [formGroup]="othersFiltersForm" class="flex flex-column justify-content-center gap-3">
      <input
        pInputText
        inputId="netKilos"
        formControlName="kilosPerBox"
        placeholder="{{'AdvancedFilters.KilosPerBoxFieldPlaceholder' | translate}}"
        class="custom-input custom-input-sm bg-form"/>

      <p-dropdown
        [options]="countries"
        formControlName="marketId"
        optionLabel="name"
        optionValue="id"
        [filter]="true"
        filterBy="name"
        autoWidth="false" [style]="{'width':'100%'}"
        [showClear]="true"
        (onChange)="handleChangeDropdown('marketId')"
        placeholder="{{'AdvancedFilters.MarketPlaceholder' | translate}}"
        class="custom-dropdown custom-dropdown-sm bg-form"
        styleClass="w-full">
        <ng-template pTemplate="selectedItem">
          <div class="flex align-items-center gap-2" *ngIf="selectedCountryFrom">
            <img loading="lazy" [flag]="selectedCountryFrom.code" style="width: 18px" alt="flag"/>
            <div>{{ selectedCountryFrom | countryDescription }}</div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img loading="lazy"[flag]="country" style="width: 18px" alt="flag"/>
            <div>{{ country | countryDescription }}</div>
          </div>
        </ng-template>
      </p-dropdown>

      <input
        pInputText
        formControlName="speciesSize"
        placeholder="{{'AdvancedFilters.SpeciesSizeFieldPlaceholder' | translate}}"
        class="custom-input custom-input-sm bg-form"
        styleClass="w-full"/>

      <input
        pInputText
        formControlName="shelfLife"
        placeholder="{{'AdvancedFilters.ShelfLife' | translate}}"
        class="custom-input custom-input-sm bg-form"
        styleClass="w-full"/>

      <input
        pInputText
        formControlName="price"
        placeholder="{{'AdvancedFilters.PricePlaceholder' | translate}}"
        class="custom-input custom-input-sm bg-form"
        styleClass="w-full"/>

      <div class="flex flex-row mt-4 p-fluid gap-2">
        <p-button
          label="{{'AdvancedFilters.ApplyFiltersText' | translate}}"
          (onClick)="executeFilter()"
          styleClass="p-button-secondary"
          class="custom-text-button header-button filter-button w-full">
          <span class="material-symbols-outlined text-lg">tune</span>
        </p-button>
        <p-button
          label="{{'UserPages.UserClosedSale.DirectSaleFilters.CleanFilters' | translate}}"
          (click)="cleanFilter()"
          class="custom-text-button header-button filter-button w-full"
          styleClass="p-button-secondary p-button-outlined">
          <span class="material-symbols-outlined text-lg">mop</span>
        </p-button>
      </div>
    </form>
  </div>
</p-sidebar>

<p-sidebar [(visible)]="sidebarPurchaseOrderVisible" position="right">
  <h3 style="text-align: center;">{{'AdvancedFilters.SideBarTitle' | translate}}</h3>

  <form [formGroup]="othersFiltersPurchaseOrderForm">
    <div class="col-12 flex justify-content-center flex-column">
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText inputId="netKilos" formControlName="kilosPerBox"
        placeholder="{{'AdvancedFilters.KilosPerBoxFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <p-dropdown
        [options]="countries"
        formControlName="marketId"
        optionLabel="name"
        optionValue="id"
        (onChange)="executeFilter()"
        [filter]="true"
        filterBy="name"
        autoWidth="false" [style]="{'width':'100%'}"
        [showClear]="true"
        placeholder="{{'AdvancedFilters.MarketPlaceholder' | translate}}"
        class="p-inputtext-sm">
        <ng-template pTemplate="selectedItem">
          <div class="flex align-items-center gap-2" *ngIf="selectedCountryFrom">
            <img [flag]="selectedCountryFrom.code" style="width: 18px" alt="flag"/>
            <div>{{ selectedCountryFrom | countryDescription }}</div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img [flag]="country" style="width: 18px" alt="flag"/>
            <div>{{ country | countryDescription }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="speciesSize" placeholder="{{'AdvancedFilters.SpeciesSizeFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="price" placeholder="{{'AdvancedFilters.PricePlaceholder' | translate}}"/>
      </div>
        <div class="col-12 flex justify-content-center">
          <p-button label="{{'AdvancedFilters.ApplyFiltersText' | translate}}" styleClass="p-button" (onClick)="executeFilterProgramRequest()">
            <span class="material-symbols-outlined">
              tune
              </span>
          </p-button>
        </div>
    </div>
  </form>
</p-sidebar>


